import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { StringService } from '../../../services/string.service';
import { PollingService } from '../../../services/polling.service';
import { MsalService } from '@azure/msal-angular';
import { AzureLoginService } from '../../../services/azure-login.service';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'kairos-nav-bar',
  templateUrl: 'kairos-nav-bar.template.html',
  styleUrls: ['kairos-nav-bar.scss'],
})
export class KairosNavBarComponent implements OnInit, OnDestroy {
  public strings: any = null;
  public showLogoutConfirmation = false;
  public currentUser$: Observable<string>;
  public fullName$: Observable<string>;
  private unsubscribe: Subject<void> = new Subject();

  public button: Array<any>;

  constructor(
    private stringService: StringService,
    private pollingService: PollingService,
    public router: Router,
    private msalService: MsalService,
    private azureService: AzureLoginService
  ) {
    // this.currentUser$ = this.store.select(getCurrentUser);
    this.fullName$ = azureService.getFullName(); // this.store.select(getFullName);

    this.stringService.strings$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((strings) => (this.strings = strings));
  }

  public ngOnInit() {
    this.button = [{ name: 'Dash', hidden: false, disabled: false, type: 'button' }];
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public confirmLogOut() {
    this.showLogoutConfirmation = true;
    this.pollingService.stopPolling();
  }

  public cancelLogOut() {
    this.showLogoutConfirmation = false;

    this.pollingService.startPolling();
  }


  public logOut() {
    this.msalService.logoutRedirect().subscribe((data) => {
      localStorage.setItem('isLogout', 'true');
      this.router.navigate(['']);
    });
  }

  public launchDash() {
    window.open(environment.dashUrl);
  }
}
